/**
 * weekdayExpensesMockData.ts — Datos demo de gastos por día de la semana.
 *
 * QUÉ HACE: genera, de forma DETERMINISTA (sin Math.random), el gasto total por
 *   cada día de la semana para los periodos Semana/Mes/Año. Sirve de respaldo
 *   cuando el negocio aún no tiene movimientos de gasto reales (modo demo).
 *
 * QUÉ NO DEBE HACER: no lee storage, no hace fetch, no conoce React.
 *
 * Exporta: WEEKDAY_EXPENSES_MOCK_DATA
 */
import type {
  WeekdayExpensePoint,
  WeekdayPeriod,
} from "../types/metrics.types";

const WEEKDAY_NAMES = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];
const WEEKDAY_SHORT = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

/**
 * Gasto base (último mes) por día, en orden Lunes → Domingo. Los gastos se
 * concentran en días hábiles (proveedores, nómina) y bajan el fin de semana.
 */
const BASE_MONTH_TOTAL = [
  3_500_000, 3_200_000, 4_100_000, 3_800_000, 5_200_000, 2_400_000, 1_900_000,
];

/** Factor aplicado al total mensual según el periodo activo. */
const PERIOD_FACTOR: Record<WeekdayPeriod, number> = {
  semana: 1 / 4.3,
  mes: 1,
  anio: 12,
};

function buildWeekdayExpenses(period: WeekdayPeriod): WeekdayExpensePoint[] {
  const factor = PERIOD_FACTOR[period];
  return WEEKDAY_NAMES.map((name, index) => ({
    weekday: index,
    name,
    shortName: WEEKDAY_SHORT[index],
    total: Math.round(BASE_MONTH_TOTAL[index] * factor),
  }));
}

export const WEEKDAY_EXPENSES_MOCK_DATA: Record<
  WeekdayPeriod,
  WeekdayExpensePoint[]
> = {
  semana: buildWeekdayExpenses("semana"),
  mes: buildWeekdayExpenses("mes"),
  anio: buildWeekdayExpenses("anio"),
};
